export default __webpack_public_path__ + "static/media/icon-close.23087db8.svg";